type CloseEscapeLayer = () => void

const layers: CloseEscapeLayer[] = []

export const registerEscapeLayer = (close: CloseEscapeLayer) => {
  layers.push(close)

  return () => {
    const index = layers.indexOf(close)

    if (index !== -1) {
      layers.splice(index, 1)
    }
  }
}

// Closing does not pop the stack: the layer leaves it only when its `open`
// flag actually flips and the hook unregisters, so a close handler that
// failed to close keeps its layer on top instead of skipping to the next one.
export const closeTopEscapeLayer = (): boolean => {
  const top = layers[layers.length - 1]

  if (!top) {
    return false
  }

  top()

  return true
}

// Radix menus (storybook DropdownMenu) dismiss themselves on Escape with the
// document-level listener of their own; while one is open the global handler
// must stay silent, otherwise a single press closes two layers. The [role]
// filter keeps Radix tooltips (same popper wrapper) from swallowing Escape.
const RADIX_MENU_SELECTOR = '[data-radix-popper-content-wrapper] [role="menu"]'

export const hasOpenRadixMenu = (): boolean =>
  document.querySelector(RADIX_MENU_SELECTOR) !== null
